<c-input-group class="d-grid gap-2 flex-nowrap p-2">
  <button id="button-submit" type="submit" cButton color="primary" (click)="onclick()" [disabled]="disabled">
    @if (!authService.actionInProgress(parentComponent)) {
      <i [ngClass]="`${iconsStyle} ${iconSize} ${icon}`"></i>
    }
    @if (authService.actionInProgress(parentComponent)) {
      <c-spinner aria-hidden="true" size="sm"></c-spinner>
    }
    {{ buttonText | translate }}
  </button>
</c-input-group>
